"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
var _lodashReplacement = _interopRequireDefault(require("./lodashReplacement"));
var _ChannelDefinition = _interopRequireDefault(require("./ChannelDefinition"));
var _SubscriptionDefinition = _interopRequireDefault(require("./SubscriptionDefinition"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  extend
} = _lodashReplacement.default;
var pubInProgress = 0;
var unSubQueue = [];
var autoCompactIndex = 0;
var _default = _config => {
  function getCachePurger(subDef, key, cache) {
    return function (sub, i, list) {
      if (sub === subDef) {
        list.splice(i, 1);
      }
      if (list.length === 0) {
        delete cache[key];
      }
    };
  }
  function getCacher(topic, pubCache, cacheKey, done, envelope) {
    var headers = envelope && envelope.headers || {};
    return function (subDef) {
      var cache;
      if (_config.resolver.compare(subDef.topic, topic, headers)) {
        if (!headers.resolverNoCache) {
          cache = pubCache[cacheKey] = pubCache[cacheKey] || [];
          cache.push(subDef);
          subDef.cacheKeys.push(cacheKey);
        }
        if (done) {
          done(subDef);
        }
      }
    };
  }
  function getSystemMessage(kind, subDef) {
    return {
      channel: _config.SYSTEM_CHANNEL,
      topic: "subscription." + kind,
      data: {
        event: "subscription." + kind,
        channel: subDef.channel,
        topic: subDef.topic
      }
    };
  }
  var sysCreatedMessage = getSystemMessage.bind(undefined, "created");
  var sysRemovedMessage = getSystemMessage.bind(undefined, "removed");
  function getPredicate(options, resolver) {
    if (typeof options === "function") {
      return options;
    } else if (!options) {
      return function () {
        return true;
      };
    } else {
      return function (sub) {
        var compared = 0;
        var matched = 0;
        Object.keys(options).forEach(function (prop) {
          compared += 1;
          if (
          // We use the bindings resolver to compare the options.topic to subDef.topic
          prop === "topic" && resolver.compare(sub.topic, options.topic, {
            resolverNoCache: true
          }) || prop === "context" && options.context === sub._context ||
          // Any other potential prop/value matching outside topic & context...
          sub[prop] === options[prop]) {
            matched += 1;
          }
        });
        return compared === matched;
      };
    }
  }
  return extend({
    configuration: _config
  }, {
    cache: {},
    subscriptions: {},
    wireTaps: [],
    ChannelDefinition: _ChannelDefinition.default,
    SubscriptionDefinition: _SubscriptionDefinition.default,
    channel: function channel(channelName) {
      return new _ChannelDefinition.default(channelName, this);
    },
    addWireTap: function addWireTap(callback) {
      var self = this;
      self.wireTaps.push(callback);
      return function () {
        var idx = self.wireTaps.indexOf(callback);
        if (idx !== -1) {
          self.wireTaps.splice(idx, 1);
        }
      };
    },
    noConflict: function noConflict() {
      /* istanbul ignore else */
      if (typeof window === "undefined" || typeof window !== "undefined" && typeof define === "function" && define.amd) {
        throw new Error("noConflict can only be used in browser clients which aren't using AMD modules");
      }
      global.postal = prevPostal;
      return this;
    },
    clearUnSubQueue: function clearUnSubQueue() {
      while (unSubQueue.length) {
        this.unsubscribe(unSubQueue.shift());
      }
    },
    getSubscribersFor: function getSubscribersFor(options) {
      var result = [];
      var self = this;
      Object.values(self.subscriptions).forEach(function (channel) {
        Object.values(channel).forEach(function (subList) {
          result = result.concat(subList.filter(getPredicate(options, _config.resolver)));
        });
      });
      return result;
    },
    publish: function publish(envelope, cb) {
      ++pubInProgress;
      var channel = envelope.channel = envelope.channel || _config.DEFAULT_CHANNEL;
      var topic = envelope.topic;
      envelope.timeStamp = new Date();
      if (this.wireTaps.length) {
        this.wireTaps.forEach(function (tap) {
          tap(envelope.data, envelope, pubInProgress);
        });
      }
      var cacheKey = channel + _config.cacheKeyDelimiter + topic;
      var cache = this.cache[cacheKey];
      var skipped = 0;
      var activated = 0;
      if (!cache) {
        var cacherFn = getCacher(topic, this.cache, cacheKey, function (candidate) {
          if (candidate.invokeSubscriber(envelope.data, envelope)) {
            activated++;
          } else {
            skipped++;
          }
        }, envelope);
        Object.values(this.subscriptions[channel] || {}).forEach(function (candidates) {
          candidates.forEach(cacherFn);
        });
      } else {
        Object.values(cache).forEach(function (subDef) {
          if (subDef.invokeSubscriber(envelope.data, envelope)) {
            activated++;
          } else {
            skipped++;
          }
        });
      }
      if (--pubInProgress === 0) {
        this.clearUnSubQueue();
      }
      if (cb) {
        cb({
          activated: activated,
          skipped: skipped
        });
      }
    },
    reset: function reset() {
      this.unsubscribeFor();
      _config.resolver.reset();
      this.subscriptions = {};
      this.cache = {};
    },
    subscribe: function subscribe(options) {
      var subscriptions = this.subscriptions;
      var subDef = new _SubscriptionDefinition.default(options.channel || _config.DEFAULT_CHANNEL, options.topic, options.callback);
      var channel = subscriptions[subDef.channel];
      var channelLen = subDef.channel.length;
      var subs;
      if (!channel) {
        channel = subscriptions[subDef.channel] = {};
      }
      subs = subscriptions[subDef.channel][subDef.topic];
      if (!subs) {
        subs = subscriptions[subDef.channel][subDef.topic] = [];
      }
      // First, add the SubscriptionDefinition to the channel list
      subs.push(subDef);
      // Next, add the SubscriptionDefinition to any relevant existing cache(s)
      var cache = this.cache;
      Object.keys(cache).forEach(function (cacheKey) {
        if (cacheKey.substr(0, channelLen) === subDef.channel) {
          getCacher(cacheKey.split(_config.cacheKeyDelimiter)[1], cache, cacheKey)(subDef);
        }
      });
      /* istanbul ignore else */
      if (_config.enableSystemMessages) {
        this.publish(sysCreatedMessage(subDef));
      }
      return subDef;
    },
    unsubscribe: function unsubscribe() {
      var unSubLen = arguments.length;
      var unSubIdx = 0;
      var subDef;
      var channelSubs;
      var topicSubs;
      var idx;
      for (; unSubIdx < unSubLen; unSubIdx++) {
        subDef = arguments[unSubIdx];
        subDef.inactive = true;
        if (pubInProgress) {
          unSubQueue.push(subDef);
          return;
        }
        channelSubs = this.subscriptions[subDef.channel];
        topicSubs = channelSubs && channelSubs[subDef.topic];
        /* istanbul ignore else */
        if (topicSubs) {
          var len = topicSubs.length;
          idx = 0;
          // remove SubscriptionDefinition from channel list
          while (idx < len) {
            /* istanbul ignore else */
            if (topicSubs[idx] === subDef) {
              topicSubs.splice(idx, 1);
              break;
            }
            idx += 1;
          }
          if (topicSubs.length === 0) {
            delete channelSubs[subDef.topic];
            if (!Object.keys(channelSubs).length) {
              delete this.subscriptions[subDef.channel];
            }
          }
          // remove SubscriptionDefinition from postal cache
          if (subDef.cacheKeys && subDef.cacheKeys.length) {
            var key;
            while (key = subDef.cacheKeys.pop()) {
              Object.values(this.cache[key]).forEach(getCachePurger(subDef, key, this.cache));
            }
          }
          if (typeof _config.resolver.purge === "function") {
            // check to see if relevant resolver cache entries can be purged
            var autoCompact = _config.autoCompactResolver === true ? 0 : typeof _config.autoCompactResolver === "number" ? _config.autoCompactResolver - 1 : false;
            if (autoCompact >= 0 && autoCompactIndex === autoCompact) {
              _config.resolver.purge({
                compact: true
              });
              autoCompactIndex = 0;
            } else if (autoCompact >= 0 && autoCompactIndex < autoCompact) {
              autoCompactIndex += 1;
            }
          }
        }
        if (_config.enableSystemMessages) {
          this.publish(sysRemovedMessage(subDef));
        }
      }
    },
    unsubscribeFor: function unsubscribeFor(options) {
      var toDispose = [];
      /* istanbul ignore else */
      if (this.subscriptions) {
        toDispose = this.getSubscribersFor(options);
        this.unsubscribe.apply(this, toDispose);
      }
    }
  });
};
exports.default = _default;